// @https://github.com/iamkun/dayjs/blob/dev/src/index.js

import { parse } from '@node-projects/node-html-parser-esm'
import dayjs from 'dayjs/esm/index.js'
import matches from './datejs-format'

const formatDateToHtml = (date: date, format: string, locale: object) => {
  const REGEX_FORMAT = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|SSS/g

  const html = format.replace(REGEX_FORMAT, (match) => {
    if (locale) {
      return `<span class="${matches[match]}">${dayjs(date).locale(locale).format(match)}</span>`
    } else {
      return `<span class="${matches[match]}">${dayjs(date).format(match)}</span>`
    }
  })

  const nodes = parse(html)
  const newNodes = []
  for (const node of nodes.childNodes) {
    if (node.nodeType === 3) {
      newNodes.push(`<span class="sep">${node._rawText}</span>`)
    } else {
      newNodes.push(node.outerHTML)
    }
  }

  return newNodes.join('')
}

export default formatDateToHtml
